import { Type } from 'class-transformer';
import { IMessage } from '../interfaces/chat.interface';

export class MessageDTO implements IMessage {
  id!: string;

  message!: string;

  @Type(() => Date)
  creationDate!: Date;

  sendType!: string;
}
